import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserFriends, faSackDollar, faClock } from "@lainco/fontawesome-duotone";
import { formatAmount } from "../../lib/misc";
import PropTypes from "prop-types";
import styled from "styled-components";

export function CashflowCell({ money, people, menHours, showMoney, showPeople, showMenHours, moneyColor, peopleColor, menHoursColor }) {
  return (
    <Cell>
      {showMoney && money != null && (
        <Line>
          <FontAwesomeIcon icon={faSackDollar} style={{ color: moneyColor }} fixedWidth />
          <Value negative={money < 0} color={moneyColor}>
            {formatAmount(money)}
          </Value>
        </Line>
      )}
      {showPeople && people != null && (
        <Line>
          <FontAwesomeIcon icon={faUserFriends} style={{ color: peopleColor }} fixedWidth />
          <Value color={peopleColor}>{formatAmount(people, { precision: 1 })}</Value>
        </Line>
      )}
      {showMenHours && menHours != null && (
        <Line>
          <FontAwesomeIcon icon={faClock} style={{ color: menHoursColor }} fixedWidth />
          <Value color={menHoursColor}>{formatAmount(menHours)}</Value>
        </Line>
      )}
    </Cell>
  );
}

CashflowCell.propTypes = {
  money: PropTypes.number,
  people: PropTypes.number,
  menHours: PropTypes.number,
  showMoney: PropTypes.bool,
  showPeople: PropTypes.bool,
  showMenHours: PropTypes.bool,
  moneyColor: PropTypes.string,
  peopleColor: PropTypes.string,
  menHoursColor: PropTypes.string,
};

CashflowCell.defaultProps = {
  showMoney: true,
  showPeople: true,
  showMenHours: true,
  moneyColor: "black",
  peopleColor: "black",
  menHoursColor: "black",
};

const Cell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3em;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const Line = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.5rem;
  width: 100%;
`;

const Value = styled.span`
  color: ${(props) => (props.color ? props.color : "black")};
  padding: ${(props) => (props.negative ? "0em" : "0em 0.35em")};
  justify-self: end;
  align-self: end;
`;
